import React, { useState, useEffect } from 'react';
import CariKendaraan2 from './CariKendaraan2';  


function InputMobilfree({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [keterangan, setKeterangan] = useState('');  
  const [status, setStatus] = useState('');
  const [detailBarang, setDetailBarang] = useState([]);
  const [idUser, setIdUser] = useState('');
  const [showCariKendaraan, setShowCariKendaraan] = useState(false);
  const [jnsKendaraan, setJnsKendaraan] = useState('SEMUA'); 
  const [canUnvalid, setCanUnvalid] = useState(true);
  const schema = localStorage.getItem('schema');

  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];  

    if (editMode && pasang) {
      const { master, details } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setKeterangan(master.KETERANGAN || '');
      setStatus(master.STATUS || '');

      if (details && Array.isArray(details)) {
        const withDisplay = details.map((item) => ({
          ...item
        }));
        setDetailBarang(withDisplay);
      } else {
        setDetailBarang([]);
      }
    } else if (pasang?.isNew) {
      setNoTransaksi(0);
      setTglTransaksi(formattedToday);
    }

    const idUser = localStorage.getItem('id_user') || '';
    setIdUser(idUser);
  }, [editMode, pasang]);


  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


const handleValidasi = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'mf');
    formData.append('id', id);
    formData.append('schema', schema);
    formData.append('id_user', idUser);
    formData.append('tgl_transaksi', tglTransaksi);
    formData.append('keterangan', keterangan);
    formData.append('detail', JSON.stringify(detailBarang));

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mobilfree.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status !== 'success') {
      alert(`Gagal validasi master: ${result.message}`);
      return;
    }

    onSave();
  } catch (err) {
    console.error('Error saat validasi Mobil Free:', err);
    alert('Terjadi kesalahan saat menyimpan Mobil Free dan detail.');
  }
};



const handleHapusDetail = (index) => {
  const updated = detailBarang.filter((_, i) => i !== index);
  const reindexed = updated.map((item, idx) => ({
    ...item,
    NOMOR: idx + 1,
  }));
  setDetailBarang(reindexed);
};

const handleTambahDetail = () => {
  setJnsKendaraan('SEMUA');
  setShowCariKendaraan(true);
};


const handlePilihKendaraan = (kendaraanList) => {
  const tambahan = kendaraanList.map((k, idx) => ({
    KD_KENDARAAN: k.KD_KENDARAAN,
    NOPOL: k.NOPOL,
    SOPIR: k.SOPIR,
  }));
  setDetailBarang([...detailBarang, ...tambahan]);
  setShowCariKendaraan(false);  
};



const handleUnvalid = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'mf_unvalid');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mobilfree.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      setStatus('0');
      alert('Mobil free berhasil unvalid');
    //  onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi mobil free.');
  }
};

const handleDelete = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'mf_hapus');
    formData.append('id', id);
    formData.append('schema', schema);

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/mobilfree.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status === 'success') {
      alert('Mobil Free berhasil dihapus');
      onSave();  
    } else {
      alert(`Gagal validasi: ${result.message}`);
    }
  } catch (err) {
    console.error('Validasi error:', err);
    alert('Terjadi kesalahan saat validasi mobil free.');
  }
};


  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

  <>

    <div>
    <label><strong>No Transaksi</strong></label>
    <input type="text" readOnly value={noTransaksi}
        style={{ width: '100%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
    />
    </div>

    <div>
    <label><strong>Tanggal</strong></label>
    <input type="date" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)}
        style={{ width: '100%', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
    />
    </div>

    <div style={{ marginBottom: '20px' }}>
    <label><strong>Keterangan</strong></label>
    <textarea
        value={keterangan}
        onChange={(e) => setKeterangan(e.target.value)}
        rows={3}
        style={{ width: '100%', padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
    />
    </div>    

    <button
      onClick={handleTambahDetail}
      disabled={status === '5' || status === '9'}
      style={{
        padding: '8px 15px',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
      }}
    >
      Tambah
    </button>


{showCariKendaraan && (
  <CariKendaraan2
    onSelect={handlePilihKendaraan}
    onCancel={() => setShowCariKendaraan(false)}
    jns_kendaraan={jnsKendaraan}
  />
)}

      {detailBarang.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '20%' }}>Kd Kendaraan</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '20%' }}>Nopol</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '30%' }}>Sopir</th>
              <th style={{ border: '1px solid #ddd', padding: '10px' }}>Aksi</th>
            </tr>
          </thead>

            <tbody>
              {detailBarang.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.KD_KENDARAAN}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.NOPOL}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.SOPIR}</td>

                  <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                    <button
                      onClick={() => handleHapusDetail(index)}
                      style={{ backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px', cursor: 'pointer'
                      }}
                      disabled={status === '5' || status === '9'}
                    >
                      Hapus
                    </button>
                  </td>                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ color: '#888' }}>Tidak ada detail.</p>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>

        <button
        onClick={handleUnvalid}
        disabled={!canUnvalid || status === '5' || status === '6'}
        style={{
            backgroundColor: !canUnvalid || status === '5' || status === '6' ? '#A5D6A7' : 'red',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: !canUnvalid || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
        }}
        >
        Un-valid
        </button>


        <button
        onClick={handleDelete}
        disabled={status === '9' || status === '5' || status === '6'}
        style={{
            backgroundColor: status === '9' || status === '5' || status === '6' ? '#A5D6A7' : 'red',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px',
            cursor: status === '9' || status === '5' || status === '6' ? 'not-allowed' : 'pointer'
        }}
        >
        Delete
        </button>        

        <button
          onClick={onCancel}
          style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}
        >
          Batal
        </button>
        <button
          onClick={handleValidasi}
          disabled={status === '5' || status === '6' || status === '9'}
          style={{
            backgroundColor: status === '5' || status === '6' || status === '9' ? '#A5D6A7' : 'green',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px'
          }}
        >
          Valid
        </button>
      </div>



    </>


    </div>
  );
}

export default InputMobilfree;
